import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";         

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};
export const waterProjectTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menuType: "menu",
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "150",
  // labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "客户姓名",
      prop: "customName",
      span: 12,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "客户电话",
      prop: "customMobile",
      span: 24,
      //overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "项目地址",
      prop: "customAddress",
      span: 24,
      overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "产品名称",
      prop: "productName",
      type: "input",
      overHidden: true,
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    /* {
      label: "其他需求",
      prop: "otherRequirements",
      type: "textarea",
      span: 24,
      max: 255,
    }, */
    {
      label: "其他产品",
      prop: "otherProducts",
      type: "input",
      overHidden: true
    },
    {
      label: "锅炉主机品牌",
      prop: "boilerBrand",
      overHidden: true,
      type: "input",
    },
    {
      label: "锅炉主机供应方式",
      prop: "supplyMode",
      type: "input",
      overHidden: true,
      dicData: DIC.BOILER_SUPPLY_TYPE,
    },
    {
      label: "浴室暖气片数量",
      prop: "numberGroups",
      type: "input",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "附加选项",
      prop: "additionalOptions",
      type: "input",
      overHidden: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "店铺名称",
      prop: "shopName",
      //overHidden: true,
      type: "input",
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    // 店铺电话
    {
      label: "店铺电话",
      prop: "shopMobile",
      //overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    // 店铺地址
    {
      label: "店铺地址",
      prop: "shopAddress",
      //overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
/*     {
      label: "安装时间",
      prop: "installTime",
      type: "datetime",
      //overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "timestamp",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    }, */
    {
      label: "备注",
      prop: "remarks",
      type: "textarea",
      span: 24,
      max: 255,
    },
    {
      label: "状态",
      prop: "orderStatus",
      type: "select",
      search: true,
      dicData: DIC.REBATE_STATUS,
      // search: true,
    },
    {
        label: "创建人",
        prop: "createBy",
        type: "input",
        hide: true,
        addVisdiplay: false,
        editVisdiplay: false,
      },
   /*  // 是否已安装
    {
      label: "是否已安装",
      prop: "isInstall",
      type: "input",
      dicData: DIC.YES_NO,
    },
    {
      label: "安装时间",
      prop: "installTime",
      type: "datetime",
      //overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 开始时间-结束时间范围搜索

    {
      label: "开始时间",
      prop: "timeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "timeEnd",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
     */
  ],
};
